import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedHelpSupportHomeHealthcare,
  updateAtmedHelpSupportHomeHealthcare
} from '../../../store/actions';
import HelpSupport from './help';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results,
  updateResult: vendorEquipmenReducer.updateResult,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedHelpSupportHomeHealthcare,
    updateAtmedHelpSupportHomeHealthcare
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(HelpSupport);
